import { render, staticRenderFns } from "./EnsuranceService.vue?vue&type=template&id=2fce2eb0&scoped=true"
import script from "./EnsuranceService.vue?vue&type=script&lang=js"
export * from "./EnsuranceService.vue?vue&type=script&lang=js"
import style0 from "./EnsuranceService.vue?vue&type=style&index=0&id=2fce2eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fce2eb0",
  null
  
)

export default component.exports